/* eslint-disable import/prefer-default-export */
import { accountContractsUrl } from '../urls';
import refresh from '../refresh';

export async function getAccountContracts() {
  return refresh(async () => {
    const response = await fetch(accountContractsUrl, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
    });
    return response;
  });
}
